import React, { forwardRef } from 'react';
import { Spinner } from 'react-bootstrap';
import TradingRulesForm from '../../TradingRules/TradingRulesForm';

/** Enable-trading-rules step body for post-onboarding orientation. */
const OrientationRulesStep = forwardRef(function OrientationRulesStep(
  { accountId, settings, saveSettings, ready },
  ref
) {
  if (!ready) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 32 }}>
        <Spinner animation="border" size="sm" variant="primary" />
      </div>
    );
  }

  return (
    <div className="trade-risk-rules-step">
      <h2 className="trade-risk-intro__heading trade-risk-rules-step__heading">
        Enable Trading Rules
      </h2>
      <TradingRulesForm
        ref={ref}
        accountId={accountId}
        settings={settings}
        saveSettings={saveSettings}
        standalone={false}
        quickSetupOnly
      />
    </div>
  );
});

export default OrientationRulesStep;
